import { api } from 'api/api';
import { AccountContext } from 'components/AccountContext';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useRoutes = () => {
  const navigate = useNavigate();
  const { user } = useContext(AccountContext);
  async function navigateByRoute(parametros) {
    switch (parametros.rota) {
      case 'telemedicina':
        if (!parametros.agenda_exames_id || parametros.agenda_exames_id === null || parametros.agenda_exames_id === undefined) {
          return;
        }
        let nome = parametros.nome;
        if (!nome || nome === null || nome === undefined || nome.trim() === '') {
          const nomePartes = user?.name.split(' ');
          const primeiroNome = nomePartes[0];
          const sobrenome = nomePartes.length > 1 ? nomePartes[1] : '';
          nome = primeiroNome + ' ' + sobrenome;
        }
        navigate('/video-chamada', {
          state: {
            channelName: `telemedicina_${parametros.agenda_exames_id}`,
            userId: `${nome}`,
            jwt: '123',
            agenda_exames_id: parametros.agenda_exames_id,
          },
        });
        break;
      case 'prontuario': {
        const key = `${parametros.agenda_exames_id}_${Date.now()}`;
        navigate('/consultas/detalhes', { state: { consultaId: parametros.agenda_exames_id, key } });
        break;
      }
      case 'telemedicina_iniciada': {
        const url = ENDPOINT + '/notifications/sendmessagetouser';
        const notificationPayload = {
          message: {
            content: {
              title: 'DeoVita',
              body: '🟢 ╌╌╌ ○ ╌╌╌ ○ \nVocê está na fila. Aguarde sua vez.',
              data: {
                rota: 'telemedicina_iniciada',
                agenda_exames_id: parametros.agenda_exames_id ,
                nome: parametros.nome || 'dsadsa',
              },
            },
            android: {
              notification: {
                tag: 'telemedicina_status_unico',
              },
            },
            apns: {
              headers: {
                'apns-collapse-id': 'telemedicina_status_unico',
              },
            },
          },
          cpf: user?.username || '',
        };
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(notificationPayload),
        };
        await api(url, requestOptions);

        const fetchTriagemAndNavigate = async (agenda_exames_id, credito_id) => {
          if (!agenda_exames_id) return;
          try {
            const response = await api(
              ENDPOINT + `/schedule/getTriagemSchedule/${agenda_exames_id}`,
              {
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                method: 'GET',
              }
            );
            const triagemData = await response.json();
            alert('Dados da triagem: ' + JSON.stringify(triagemData));
            navigate('/medico-agora/atendimento', {
              state: {
                patient: triagemData.cpf,
                triagem: triagemData,
                faturado: true,
                credito: credito_id,
                status: 'telemed_paga',
              },
            });
          } catch (error) {
            alert('Erro ao buscar triagem: ' + error);
          }
        };
        if (!parametros.agenda_exames_id) return;
        await fetchTriagemAndNavigate(parametros.agenda_exames_id, parametros.credito_id);
        break;
      }
      case 'telemedicina_medico_na_sala': {
        if (!parametros.agenda_exames_id || parametros.agenda_exames_id === null || parametros.agenda_exames_id === undefined) {
          return;
        }
        let nome = parametros.nome;
        if (!nome || nome === null || nome === undefined || nome.trim() === '') {
          const nomePartes = user?.name.split(' ');
          const primeiroNome = nomePartes[0];
          const sobrenome = nomePartes.length > 1 ? nomePartes[1] : '';
          nome = primeiroNome + ' ' + sobrenome;
        }
        navigate('/video-chamada', {
          state: {
            channelName: `telemedicina_${parametros.agenda_exames_id}`,
            userId: `${nome}`,
            jwt: '123',
            agenda_exames_id: parametros.agenda_exames_id,
          },
        });
        break;
      }
      case 'telemedicina_encerrada': {
        if (!parametros.agenda_exames_id || parametros.agenda_exames_id === null || parametros.agenda_exames_id === undefined) {
          return;
        }
        navigate('/video-chamada/avaliacao', {
          state: {
            agenda_exames_id: parametros.agenda_exames_id,
          },
        });
        break;
      }
      default:
        return;
    }
  }
  return navigateByRoute;
};
export default useRoutes;
